/**
 * VEIL BUILDER - Interactive Click & Drag Product Customizer
 */

(function() {
  'use strict';

  const state = {
    canvas: null,
    currentStep: 1,
    selectedVeil: null,
    selectedLace: null,
    placedDetails: [],
    veilObject: null,
    laceObject: null,
    historyStack: [],
    totalPrice: 0,
    detailCounter: 0,
    productData: null,
  };

  const CONFIG = window.VeilBuilderConfig || {
    basePrice: 15000,
    addonVariantId: null,
    imgbbApiKey: null
  };

  function init() {
    loadProductData();
    if (typeof fabric === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    setupCanvas();
    setupEventListeners();
    setupDragAndDrop();
    
    // Auto-select the very first veil option
    const firstVeil = document.querySelector('.vb-veil-option');
    if (firstVeil) {
      selectVeil(firstVeil);
    }

    showStep(1);
    updateTotalPrice();
  }

  function loadProductData() {
    const productDataEl = document.getElementById('veil-product-data');
    if (productDataEl) {
      try {
        state.productData = JSON.parse(productDataEl.textContent);
      } catch (e) {
        console.error('Failed to parse product data:', e);
      }
    }
  }

  function setupCanvas() {
    const wrapper = document.getElementById('canvas-wrapper');
    if (!wrapper) return;
    
    const isMobile = window.innerWidth <= 768;
    const width = isMobile ? Math.min(wrapper.offsetWidth - 20, 350) : Math.min(wrapper.offsetWidth - 20, 600);
    const height = isMobile ? 400 : 550;

    state.canvas = new fabric.Canvas('veil-canvas', {
      width: width, height: height, backgroundColor: '#faf8f5', selection: true
    });

    fabric.Object.prototype.set({ transparentCorners: false, cornerColor: '#c9a87c', cornerStrokeColor: '#ffffff', cornerSize: 12, cornerStyle: 'circle', borderColor: '#c9a87c', borderScaleFactor: 2, padding: 8 });
    window.addEventListener('resize', debounce(handleResize, 250));
  }

  function setupEventListeners() {
    document.querySelectorAll('.vb-veil-option').forEach(el => el.addEventListener('click', () => selectVeil(el)));
    document.getElementById('btn-next-1')?.addEventListener('click', () => showStep(2));
    document.getElementById('btn-next-2')?.addEventListener('click', () => showStep(3));
    document.getElementById('btn-back-1')?.addEventListener('click', () => showStep(1));
    document.getElementById('btn-back-2')?.addEventListener('click', () => showStep(2));
    document.getElementById('btn-undo')?.addEventListener('click', undo);
    document.getElementById('btn-delete')?.addEventListener('click', deleteSelected);
    document.getElementById('btn-clear')?.addEventListener('click', clearAll);
    document.querySelectorAll('input[name="lace"]').forEach(radio => radio.addEventListener('change', (e) => selectLace(e.target)));
    document.getElementById('btn-add-cart')?.addEventListener('click', addToCart);
    document.querySelectorAll('.vb-detail-item').forEach(el => el.addEventListener('click', () => addDetailToCanvas(el)));
    state.canvas.on('selection:created', onSelectionChange);
    state.canvas.on('selection:updated', onSelectionChange);
    state.canvas.on('selection:cleared', onSelectionCleared);
    state.canvas.on('object:modified', saveHistory);
    document.addEventListener('keydown', (e) => {
      const activeObj = state.canvas.getActiveObject();
      if ((e.key === 'Delete' || e.key === 'Backspace') && activeObj && activeObj.isDetail) {
        e.preventDefault();
        deleteSelected();
      }
    });
  }

  function setupDragAndDrop() {
    const dropZone = document.getElementById('drop-zone');
    const canvasWrapper = document.getElementById('canvas-wrapper');
    if (!dropZone || !canvasWrapper) return;

    document.querySelectorAll('.vb-detail-item').forEach(el => {
      el.addEventListener('dragstart', (e) => {
        e.dataTransfer.setData('application/json', JSON.stringify({
          id: el.dataset.detailId, name: el.dataset.detailName, price: parseInt(el.dataset.detailPrice) || 0, image: el.dataset.detailImage,
        }));
        dropZone.classList.add('active');
      });
      el.addEventListener('dragend', () => dropZone.classList.remove('active'));
    });

    canvasWrapper.addEventListener('dragover', (e) => { e.preventDefault(); dropZone.classList.add('active'); });
    canvasWrapper.addEventListener('dragleave', (e) => { if (!canvasWrapper.contains(e.relatedTarget)) dropZone.classList.remove('active'); });
    canvasWrapper.addEventListener('drop', (e) => {
      e.preventDefault(); dropZone.classList.remove('active');
      try {
        const data = JSON.parse(e.dataTransfer.getData('application/json'));
        const rect = state.canvas.getElement().getBoundingClientRect();
        addDetailAtPosition(data, (e.clientX - rect.left) * (state.canvas.width / rect.width), (e.clientY - rect.top) * (state.canvas.height / rect.height));
      } catch (err) {}
    });
  }

  function selectVeil(el) {
    document.querySelectorAll('.vb-veil-option').forEach(opt => opt.classList.remove('selected'));
    el.classList.add('selected');
    state.selectedVeil = { id: el.dataset.veilId, name: el.dataset.veilName, price: parseInt(el.dataset.veilPrice) || 0, image: el.dataset.veilImage };
    document.getElementById('btn-next-1').disabled = false;
    if (state.selectedVeil.image) loadVeilOnCanvas(state.selectedVeil.image);
    updateTotalPrice();
  }

  function loadVeilOnCanvas(imageSrc) {
    if (state.veilObject) state.canvas.remove(state.veilObject);
    fabric.Image.fromURL(imageSrc, (img) => {
      if (!img) return;
      const scale = Math.min((state.canvas.width * 0.85) / img.width, (state.canvas.height * 0.9) / img.height);
      img.set({ scaleX: scale, scaleY: scale, left: state.canvas.width / 2, top: state.canvas.height / 2, originX: 'center', originY: 'center', selectable: false, evented: false, isVeil: true });
      state.veilObject = img;
      state.canvas.add(img);
      state.canvas.sendToBack(img);
      state.canvas.renderAll();
      if (state.selectedLace) applyLaceToCanvas();
    }, { crossOrigin: 'anonymous' });
  }

  function addDetailToCanvas(el) {
    const data = { id: el.dataset.detailId, name: el.dataset.detailName, price: parseInt(el.dataset.detailPrice) || 0, image: el.dataset.detailImage };
    addDetailAtPosition(data, state.canvas.width / 2 + (Math.random() - 0.5) * 100, state.canvas.height / 2 + (Math.random() - 0.5) * 100);
  }

  function addDetailAtPosition(data, x, y) {
    if (!data.image) return;
    const detailId = `detail_${++state.detailCounter}`;
    fabric.Image.fromURL(data.image, (img) => {
      if (!img) return;
      const FIXED_SIZE = 60;
      img.set({
        scaleX: FIXED_SIZE / img.width,
        scaleY: FIXED_SIZE / img.height,
        left: x,
        top: y,
        originX: 'center',
        originY: 'center',
        hasControls: true,        // must be true for rotation to show
        hasBorders: true,
        lockScalingX: true,
        lockScalingY: true,
        lockScalingFlip: true,
        isDetail: true,
        detailData: { id: detailId, type: data.id, name: data.name, price: data.price }
      });

      img.setControlsVisibility({
        ml: false,   // middle left
        mr: false,   // middle right
        mt: false,   // middle top
        mb: false,   // middle bottom
        bl: false,   // bottom left corner
        br: false,   // bottom right corner
        tl: false,   // top left corner
        tr: false,   // top right corner
        mtr: true    // rotation handle - KEEP THIS
      });
      state.canvas.add(img);
      state.canvas.setActiveObject(img);
      state.canvas.renderAll();
      state.placedDetails.push({ id: detailId, type: data.id, name: data.name, price: data.price, fabricObj: img });
      saveHistory(); updateDetailCount(); updateTotalPrice(); showToast(`${data.name} added!`);
    }, { crossOrigin: 'anonymous' });
  }

  function selectLace(input) {
    if (state.laceObject) { state.canvas.remove(state.laceObject); state.laceObject = null; }
    if (input.value === 'none') { state.selectedLace = null; updateTotalPrice(); state.canvas.renderAll(); return; }
    state.selectedLace = { id: input.value, name: input.dataset.laceName, price: parseInt(input.dataset.lacePrice) || 0, image: input.dataset.laceImage };
    applyLaceToCanvas();
    updateTotalPrice();
  }

  function applyLaceToCanvas() {
    if (!state.selectedLace?.image || !state.veilObject) return;
    if (state.laceObject) { state.canvas.remove(state.laceObject); state.laceObject = null; }
    fabric.Image.fromURL(state.selectedLace.image, (img) => {
      if (!img) return;
      img.set({
        scaleX: state.veilObject.scaleX,
        scaleY: state.veilObject.scaleY,
        left: state.veilObject.left,
        top: state.veilObject.top,
        originX: state.veilObject.originX,
        originY: state.veilObject.originY,
        selectable: false,
        evented: false,
        isLace: true,
        angle: state.veilObject.angle
      });
      state.laceObject = img;
      state.canvas.add(img);
      const veilIndex = state.canvas.getObjects().indexOf(state.veilObject);
      state.canvas.moveTo(img, veilIndex + 1);
      state.canvas.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  function onSelectionChange() { document.getElementById('btn-delete').disabled = !(state.canvas.getActiveObject()?.isDetail); }
  function onSelectionCleared() { document.getElementById('btn-delete').disabled = true; }
  function deleteSelected() {
    const obj = state.canvas.getActiveObject();
    if (!obj || !obj.isDetail) return;
    state.canvas.remove(obj);
    state.placedDetails = state.placedDetails.filter(d => d.id !== obj.detailData.id);
    saveHistory(); updateDetailCount(); updateTotalPrice();
    document.getElementById('btn-delete').disabled = true;
    showToast('Detail removed');
  }

  function clearAll() {
    if (state.placedDetails.length === 0 || !confirm('Remove all details?')) return;
    state.canvas.getObjects().filter(obj => obj.isDetail).forEach(obj => state.canvas.remove(obj));
    state.placedDetails = [];
    saveHistory(); updateDetailCount(); updateTotalPrice();
  }

  function undo() {
    if (state.placedDetails.length === 0) return;
    const last = state.placedDetails.pop();
    if (last?.fabricObj) state.canvas.remove(last.fabricObj);
    state.historyStack.pop();
    updateDetailCount(); updateTotalPrice(); updateUndoButton();
  }

  function saveHistory() {
    state.historyStack.push(state.placedDetails.length);
    if (state.historyStack.length > 20) state.historyStack.shift();
    updateUndoButton();
  }

  function updateUndoButton() { document.getElementById('btn-undo').disabled = state.placedDetails.length === 0; }
  function updateDetailCount() { document.getElementById('detail-count').textContent = state.placedDetails.length; }

  function updateTotalPrice() {
    let total = CONFIG.basePrice || 0;
    if (state.selectedVeil) total += state.selectedVeil.price || 0;
    state.placedDetails.forEach(d => total += d.price || 0);
    if (state.selectedLace) total += state.selectedLace.price || 0;
    state.totalPrice = total;
    document.getElementById('total-price').textContent = formatMoney(total);
  }

  function formatMoney(cents) { return '£' + (cents / 100).toFixed(2); }

  function showStep(stepNum) {
    state.currentStep = stepNum;
    document.querySelectorAll('.vb-step').forEach(el => {
      const num = parseInt(el.dataset.step);
      el.classList.remove('active', 'completed');
      if (num === stepNum) el.classList.add('active');
      if (num < stepNum) el.classList.add('completed');
    });
    document.querySelectorAll('.vb-panel').forEach(p => p.classList.remove('active'));
    document.getElementById(`panel-${stepNum}`)?.classList.add('active');
    if (stepNum === 3) generateSummary();
  }

  function generateSummary() {
    updateTotalPrice();
    const summaryEl = document.getElementById('order-summary');
    if (!summaryEl) return;
    let html = `<div class="vb-summary-item"><span>Base Price</span><span>${formatMoney(CONFIG.basePrice)}</span></div>`;
    if (state.selectedVeil) html += `<div class="vb-summary-item"><span>Veil: ${state.selectedVeil.name}</span><span>${state.selectedVeil.price > 0 ? formatMoney(state.selectedVeil.price) : 'Included'}</span></div>`;
    
    const detailCounts = {};
    state.placedDetails.forEach(d => {
      if (!detailCounts[d.name]) detailCounts[d.name] = { count: 0, unitPrice: d.price };
      detailCounts[d.name].count++;
    });
    Object.entries(detailCounts).forEach(([name, info]) => { html += `<div class="vb-summary-item"><span>${name} × ${info.count}</span><span>${formatMoney(info.count * info.unitPrice)}</span></div>`; });
    if (state.selectedLace) html += `<div class="vb-summary-item"><span>Lace: ${state.selectedLace.name}</span><span>${formatMoney(state.selectedLace.price)}</span></div>`;
    summaryEl.innerHTML = html;
  }

  async function uploadToImgBB(dataURL) {
    if (!CONFIG.imgbbApiKey) return null;
    try {
      const formData = new FormData();
      formData.append("image", dataURL.split(',')[1]); // removes base64 prefix
      const res = await fetch(`https://api.imgbb.com/1/upload?key=${CONFIG.imgbbApiKey}`, { method: 'POST', body: formData });
      const data = await res.json();
      return data.data.url; // Native public link!
    } catch (e) {
      console.error('ImgBB upload failed', e);
      return null;
    }
  }

  async function addToCart() {
    const btn = document.getElementById('btn-add-cart');
    if (!btn) return;
    btn.disabled = true;
    
    try {
      btn.textContent = 'Generating Image...';
      const highResPreview = state.canvas.toDataURL({ format: 'png', quality: 1, multiplier: 1024 / state.canvas.width });
      
      btn.textContent = 'Saving Design...';
      const publicImageUrl = await uploadToImgBB(highResPreview);

      const baseVariantId = state.productData?.firstVariantId;
      const baseVariantPrice = state.productData?.variants?.[0]?.price || 0;
      
      const detailCounts = {};
      state.placedDetails.forEach(d => { if (!detailCounts[d.name]) detailCounts[d.name] = { count: 0, unitPrice: d.price }; detailCounts[d.name].count++; });

      const properties = {
        'Veil Style': state.selectedVeil?.name || 'Custom',
        'Lace Trim': state.selectedLace ? `${state.selectedLace.name} (${formatMoney(state.selectedLace.price)})` : 'None',
        'Details': Object.entries(detailCounts).map(([name, info]) => `${name} ×${info.count}`).join(', ') || 'None',
        'Design Total': formatMoney(state.totalPrice)
      };

      if (publicImageUrl) {
        properties['Design Preview'] = publicImageUrl; // Shows native link in Shopify
      }

      // Add main product
      const itemsToCart = [{
        id: baseVariantId,
        quantity: 1,
        properties: properties
      }];

      // Exact pricing add-on check
      const extraCost = state.totalPrice - baseVariantPrice;
      if (extraCost > 0 && CONFIG.addonVariantId) {
        itemsToCart.push({
          id: parseInt(CONFIG.addonVariantId),
          quantity: extraCost / 100, // assuming currency base is 100
          properties: { 'For Item': 'Custom Veil Add-ons' }
        });
      }

      btn.textContent = 'Adding to cart...';
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itemsToCart })
      });

      if (!response.ok) throw new Error('Failed to add to cart');
      
      showToast('✓ Added to cart!');
      setTimeout(() => window.location.href = '/cart', 1200);

    } catch (error) {
      showToast('Error: ' + error.message);
      btn.disabled = false;
      btn.textContent = '🛒 Add to Cart';
    }
  }

  function showToast(msg) {
    document.querySelector('.vb-toast')?.remove();
    const toast = document.createElement('div');
    toast.className = 'vb-toast'; toast.textContent = msg;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.remove(), 300); }, 3000);
  }

  function handleResize() {
    const wrapper = document.getElementById('canvas-wrapper');
    if (!wrapper || !state.canvas) return;
    const isMobile = window.innerWidth <= 768;
    const newW = isMobile ? Math.min(wrapper.offsetWidth - 20, 350) : Math.min(wrapper.offsetWidth - 20, 600);
    const newH = isMobile ? 400 : 550;
    if (Math.abs(state.canvas.width - newW) > 50) {
      const sX = newW / state.canvas.width; const sY = newH / state.canvas.height;
      state.canvas.setDimensions({ width: newW, height: newH });
      state.canvas.getObjects().forEach(obj => { obj.set({ left: obj.left * sX, top: obj.top * sY, scaleX: obj.scaleX * sX, scaleY: obj.scaleY * sY }); obj.setCoords(); });
      state.canvas.renderAll();
    }
  }

  function debounce(func, wait) {
    let timeout; return (...args) => { clearTimeout(timeout); timeout = setTimeout(() => func.apply(this, args), wait); };
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();